export default __webpack_public_path__ + "b9baad3d175353c1e038f3d0c9f6464f.png";